export function getTenantHeaders() {
  // encode account with Base64
  const tenantPermission = btoa(localStorage.getItem('tenant_permission'));
  const headers = {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    'presense-tenant': tenantPermission,
    roleid: localStorage.getItem('role_id'),
  };
  return headers;
}
